var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineVideoRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 .25 0 .5-.02.74-.03.32-.25.58-.56.66a.742.742 0 0 1-.81-.31.875.875 0 0 1-.08-.1c-.69-.79-1.7-1.24-2.77-1.24a3.741 3.741 0 0 0-3.21 5.68c.19.32.43.6.7.84l.12.11c.23.19.34.52.25.81a.75.75 0 0 1-.63.54c-.23.02-.49.02-.74.02H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h5.03c-.01-.01-.02-.03-.03-.04-.5-.83-.76-1.76-.76-2.71 0-1.38.53-2.68 1.48-3.66a5.29 5.29 0 0 1 3.77-1.59c.99 0 1.94.27 2.75.78V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52 7.86c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18.96a.749.749 0 1 1 0 1.5H2.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77 6.97V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.86c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.73 6.52V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.41c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.27 22.61c-.03-.02-.06-.04-.08-.06-.09-.08-.15-.12-.2-.18-.35-.3-.69-.7-.97-1.16-.5-.83-.76-1.76-.76-2.71 0-1.38.53-2.68 1.48-3.66a5.29 5.29 0 0 1 3.77-1.59c1.51 0 2.93.64 3.91 1.76.05.04.13.14.2.24.72.87 1.15 2.04 1.15 3.25 0 .44-.05.85-.15 1.24-.12.5-.32.99-.6 1.46a5.328 5.328 0 0 1-4.52 2.55c-1.18 0-2.33-.4-3.23-1.14zm.89-1.21c.66.55 1.46.84 2.34.84 1.31 0 2.53-.7 3.21-1.82.2-.33.34-.69.43-1.06.07-.28.11-.56.11-.87 0-.86-.3-1.69-.85-2.35-.01-.01-.12-.14-.13-.16-.69-.79-1.7-1.24-2.77-1.24a3.741 3.741 0 0 0-3.21 5.68c.19.32.43.6.7.84l.1.09c.02.02.05.03.07.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.17 20.21-2.38-2.38a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.38 2.38c.29.29.29.77 0 1.06-.14.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.77 20.23a.754.754 0 0 1 0-1.06l2.38-2.38c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.38 2.38c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoRemove);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-remove.36da15ed2ec4ffdb14550c71b9ce8ec0.svg";
export { ForwardRef as ReactComponent };